import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { trustSanitizedHtml } from "src/app/others/security/safe-html";

@Pipe({
  name: 'sanitizer'
})
export class SanitizerPipe implements PipeTransform {
  trustedHtmlImpression: any;
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: any) {
    this.trustedHtmlImpression = trustSanitizedHtml(this.sanitizer, value);
    return this.trustedHtmlImpression;
  }

}
